import React from 'react'
import { Link } from 'react-router-dom'

import './BlogPage.scss'

function CommentCard(props) {
    return (
        <div className='CommentCard_otr'>
            <div className="profile_otr">
                <div className="profile_inr">
                    <img className="profile_img" src={props.CardImg} alt="img" />
                    <Link className="name heading_SB">{props.UserName} <span className="name-inr">.  {props.CardDate}</span></Link>
                </div>
                <Link className="btn_stores heading_SB">Reply</Link>
            </div>
            <p className="desc heading_S">{props.CardDesc}</p>
        </div>
    )
}

export default CommentCard